var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-dialog",
    _vm._b(
      {
        attrs: {
          fullscreen: _vm.fullscreen,
          "content-class": "overflow-visible"
        },
        on: {
          input: function($event) {
            return _vm.$emit("change", $event)
          }
        },
        scopedSlots: _vm._u(
          [
            {
              key: "activator",
              fn: function({ on: { click } }) {
                return [
                  _vm.hasSlotActivator
                    ? _vm._t("activator", null, { click: click })
                    : _c("custom-btn-icon", {
                        attrs: {
                          "btn-text": _vm.btnText,
                          "tooltip-text": _vm.btnTooltip,
                          color: _vm.btnColor || _vm.color,
                          icon: _vm.icon,
                          disabled: _vm.disabled
                        },
                        on: {
                          click: [
                            function($event) {
                              $event.preventDefault()
                              return click.apply(null, arguments)
                            },
                            function($event) {
                              $event.preventDefault()
                              return _vm.emitPopup.apply(null, arguments)
                            }
                          ]
                        }
                      })
                ]
              }
            }
          ],
          null,
          true
        ),
        model: {
          value: _vm.dialog,
          callback: function($$v) {
            _vm.dialog = $$v
          },
          expression: "dialog"
        }
      },
      "v-dialog",
      _vm.$attrs,
      false
    ),
    [
      _vm._v(" "),
      _c("custom-dialog", {
        attrs: {
          color: _vm.color,
          icon: _vm.icon,
          title: _vm.title,
          fullscreen: _vm.fullscreen
        },
        on: {
          close: _vm.handleCloseClick,
          fullscreen: _vm.handleFullscreenClick
        },
        scopedSlots: _vm._u(
          [
            {
              key: "actions",
              fn: function() {
                return [_vm._t("actions")]
              },
              proxy: true
            },
            {
              key: "default",
              fn: function() {
                return [_vm._t("default")]
              },
              proxy: true
            }
          ],
          null,
          true
        )
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }